import metadata from 'libphonenumber-js/min/metadata'

import { createPhoneInput } from '../modules/react-hook-form/PhoneInput.js'

export default createPhoneInput(metadata)